export const FILTERS_IN_PARAMS = [
  'filter_destinations',
  'filter_categories',
  'filter_amenities',
  'filter_specialties',
  'filter_offers',
]
